<div *ngIf="userHasVoted === null">
  <span class="body-default-regular text-grey-800">N/A</span>
</div>

<div *ngIf="userHasVoted">
  <span class="material-symbols-rounded text-green-500">check</span>
</div>

<div *ngIf="userHasVoted === false">
  <span class="body-default-regular text-grey-800">No</span>
</div>
